import { Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'zc-block-tree-node',
  template: `<ng-container *ngFor="let block of pageBlocks;let bIndx=index;">
  <zc-block-tree-node [widgetProperties]="widgetProperties" class="block" [ngClass]='block.definition?.style' [ngStyle]="block.definition?.inlineStyle" *ngIf="block.info.type=='block'"
    [pageBlocks]="block.definition.widgets"></zc-block-tree-node>
  <app-com-render  *ngIf="block.info.type !='block'" [properties]="widgetProperties"
    [type]='block.info.type' [data]="block">
   
  </app-com-render>
</ng-container>
<!-- <ng-container *ngFor="let c of block.definition.widgets;let indx=index">
    {{c.info.type }}
    <app-block-tree-node [ngClass]='c.definition.style' *ngIf="c.info.type=='block'" [pageBlocks]="c.definition.widgets"></app-block-tree-node>
    <app-com-render *ngIf="c.info.type !='block'" [type]='c.info.type' [data]="c"></app-com-render>
  </ng-container> -->`,
  styles: [`.setting{display:none;padding:2px;position:absolute;right:0;top:0;background-color:red}.setting i{margin-left:5px}.trash{padding:0;position:absolute;right:20;top:0}`]
})
export class BlockTreeNodeComponent implements OnInit {

  @Input() pageBlocks: any[] = [];
  @Input() widgetProperties: any;
  constructor() { }
  ngOnInit() {
  }
}
